import styled from 'styled-components';

export const DefaultButton = styled.button`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.COLORS.secondaryMiddle};
  border-radius: 30px;
  padding: 0.5em 0.7em;
  color: ${({ theme }) => theme.COLORS.textDark};
  font-size: ${({ theme }) => theme.FONT_SIZES.primary};
  transition: background-color 0.3s ease;
  font-weight: 400;

  &:hover {
    background-color: ${({ theme }) => theme.COLORS.primaryMiddle};
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.COLORS.secondaryLight};
  }
`;
